module.exports = __webpack_public_path__ + "static/ml-18e020dafe280a06d9fdc74736ba1a3f.jpg";